import { ICollectionLine } from 'shared-pages/pages/collections/form/collectionExtras-table';
import { v4 as uuidv4 } from 'uuid';

export enum Company {
  Rebattery = 'RE-BATTERY',
  RebatteryLiion = 'RE-BATTERY-LIION',
  Fotokiklosi = 'FOTOKIKLOSI',
  AfisCyprus = 'AFIS-CYPRUS',
  Medicycle = 'MEDICYCLE',
  Combatt = 'COMBATT',
}

export const CurrentAppCompany = process.env.VITE_APP_COMPANY;

export { isFieldTooltipEnabled } from 'motion-components';
export const isRebattery =
  CurrentAppCompany === Company.Rebattery ||
  CurrentAppCompany === Company.RebatteryLiion;
export const isRebatteryLiion =
  CurrentAppCompany === Company.Rebattery ||
  CurrentAppCompany === Company.RebatteryLiion;
export const isFotokiklosi = process.env.VITE_APP_COMPANY === Company.Fotokiklosi;
export const isAfisCyprus = process.env.VITE_APP_COMPANY === Company.AfisCyprus;
export const isMedicycle = process.env.VITE_APP_COMPANY === Company.Medicycle;
export const isCombatt = process.env.VITE_APP_COMPANY === Company.Combatt;

export const requiredString = 'Το πεδίο είναι υποχρεωτικό';

export enum UserRoles {
  All = 0,
  Admin = 1,
}

export const FILESREPO_S3FOLDER = 'filesrepo';

export enum Modelnames {
  User = 'User',
}

export enum CstTypes {
  SUPPLIERS = '8FBA9789-B38C-4F70-B59B-26F56D9C05C0',
  CUSTOMERS = 'F9A2F69B-CEBF-4AE0-A1DF-6E65C1138386',
  OWNERS = '03AF9415-1D62-4430-A8EC-3609CB14554C',
  TRANSP_CO = 'ADFC80C2-495C-4EB4-9F55-8FB0C53143B1',
  FINAL_CUST = 'C0CB5A33-0FAD-487D-A1F2-757C8E31C26C',
  DRIVERS = '5CFE9B2B-4180-41F1-AB8E-56C7CB836278',
  CONTRACTORS = '8593AC59-78F7-47F9-BB30-45138317E830',
}

export enum DocFilter {
  expired = 'expired',
  onemonth = 'onemonth',
  blank = 'blank',
}

// Σειρές Αρίθμησης
export enum NumberingSeries {
  IDocs = 101, // Έντυπα Αναγνώρισης
  Collections = 102, // Συλλογές
  ContainerOrders = 103, // Παραγγελίες Κάδων
  Order = 105, // Αίτηση Συλλογής
  VehRoutes = 104, // Δρομολόγια Οχημάτων
  ITrans = 106, // Εσωτερικές Μετακινήσεις
  Production = 107, // Παραγωγή
}

// Δρομολόγια
export enum RouteStates {
  Planned = 1, // Προγραμματισμένο
  Executed = 2, // Ολοκληρωμένο
}
export enum RouteLinesStates {
  Planned = 1, // Προγραμματισμένο
  Executed = 2, // Ολοκληρωμένο
}

// Αιτήσεις
export enum CollectionOrderStates {
  NotRouted = 1,
  Routed = 2,
  Executed = 3,
  // Re Battery Liion specific states
  TemporarySaved = 0,
  ApplicationSubmitted = 4,
  /** Fotokiklosi: Παραληφθείσα από Οδηγό (ίδιο value με ApplicationSubmitted) */
  CollectedByDriver = 4,
  ApplicationRejected = 5,
  OrganizationCompleted = 6,
  PackageShipmentCompleted = 7,
  CollectorOrder = 8,
  ScheduledCollectorCollection = 9,
}
// (1032, 1, 4, "Υποβολή Αίτησης", 1, CURDATE(), CURDATE(), "AUTO", "AUTO"),
// (1032, 2, 5, "Η Αίτηση Απορρίφθηκε", 1, CURDATE(), CURDATE(), "AUTO", "AUTO"),
// (1032, 3, 6, "Ολοκλήρωση Οργάνωσης", 1, CURDATE(), CURDATE(), "AUTO", "AUTO"),
// (1032, 4, 7, "Ολοκλήρωση Αποστολής Συσκευασιών", 1, CURDATE(), CURDATE(), "AUTO", "AUTO"),
// (1032, 5, 8, "Εντολή Συλλέκτη", 1, CURDATE(), CURDATE(), "AUTO", "AUTO"),
// (1032, 6, 9, "Προγραμματισμένη Συλλογή Συλλέκτη", 1, CURDATE(), CURDATE(), "AUTO", "AUTO"),

// Τύποι Καταχωρήσεων Οδηγών
export enum DriverAppCommandTypes {
  CollectionOrderExecution = 101, // Εντολή Συλλογής απο Αίτηση
  RouteOrderExecution = 102, // Εντολή Δρομολογίου
  NewCollectionExecution = 103, // Νέα Εντολή Συλλογής χωρίς Αίτηση
  PlaceContainerQrCode = 104, // Τοποθέτηση Κωδικού QR σε Κάδο
  RouteCompletion = 105,
  ContainersOrderExecution = 106,
  /** Δήλωση συλλογής από οδηγό χωρίς καταχώρηση Collection */
  RouteOrderDeclaration = 107,
  /** Προσθήκη σημείωσης σε αίτηση χωρίς αλλαγή κατάστασης */
  RouteOrderAddNote = 108,
}

export const FOTOKIKLOSI_DEFAULT_MATERIALS: ICollectionLine[] = [
  {
    id: null,
    aa: 1,
    materialId: 6,
    qty: 0,
    netWeight: 0,
    material: { id: 6, name: 'ΣΥΛΛΟΓΗ ΑΗΗΕ 200136' },
    finDispNote: '',
    tempId: uuidv4(),
    jobtypeId: null,
    jobtype: { id: null, description: '' },
  },
  {
    id: null,
    aa: 2,
    materialId: 1,
    qty: 0,
    netWeight: 0,
    material: { id: 1, name: 'ΣΥΛΛΟΓΗ ΑΗΗΕ 200121*' },
    finDispNote: '',
    tempId: uuidv4(),
    jobtypeId: null,
    jobtype: { id: null, description: '' },
  },
];

export const AFISCYPRUS_DEFAULT_MATERIALS: ICollectionLine = {
  id: null,
  aa: 1,
  materialId: 1,
  qty: 1,
  netWeight: 0,
  material: { id: 1, name: 'Μικτές Μπαταρίες' },
  finDispNote: '',
  tempId: uuidv4(),
  jobtypeId: null,
  jobtype: { id: null, description: '' },
};

export const REBATTERYLIION_DEFAULT_MATERIALS: ICollectionLine = {
  id: null,
  aa: 1,
  materialId: 4,
  qty: 1,
  netWeight: 0,
  material: { id: 4, name: 'Li - Ion' },
  finDispNote: '',
  tempId: uuidv4(),
  jobtypeId: null,
  jobtype: { id: null, description: '' },
};

export const CompanyVatTitle = isAfisCyprus || isMedicycle ? 'Αριθμός ΦΠΑ' : 'Α.Φ.Μ.';
export const regionsTitle = isAfisCyprus || isMedicycle ? 'Επαρχίες' : 'Περιφέρειες';
export const regionTitle = isAfisCyprus || isMedicycle ? 'Επαρχία' : 'Περιφέρεια';
